import { requestGet } from '@/common/request';

// 1订阅 2取消订阅
export default async function marketingPlanSubscribe(query: {
  type: 1 | 2;
  marketingPlanCode: string;
}): Promise<RequestResult<{}>> {
  return await requestGet('/marketingPlan/subscribe', query);
}
